import { cn } from '@Core/Helpers';
import React, { ComponentProps, forwardRef } from "react";

interface ContainerProps extends ComponentProps<"div"> {
    fullContainer?: boolean;
}

const Container = forwardRef<
    HTMLInputElement,
    ContainerProps
>(
    ({ className, fullContainer, ...props }, ref) => (
        <div
            className={cn(
                fullContainer ? 'w-full' : 'container',
                className
            )}
            ref={ref}
            {...props}
        />
    )
);

Container.displayName = "Container";

export { Container };
